import {
  EmployeeOrdersBreadcrumb,
  EmployeeOrdersNavi,
  EmployeeOrdersWrapper,
} from '../../../../../components/EmployeeOrdersWrapper/EmployeeOrdersWrapper.js';
import { Grid } from '../../../../../components/Grid/Grid.js';
import { RedeemRequestList } from '../../../../../components/SubscriptionAction/RedeemRequestList';
import { getFilteredSubscriptionActions } from '../../../../../common/utils/employeeUtils.js';
import { omaElisaForEmployeeMsg, orderRequestsMsg, t } from '../../../../../common/i18n/index.js';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useAuth } from '../../../AuthProvider';
import { useLoaderData } from 'react-router-dom';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import type { SubscriptionActionsResponse } from '../../../../../generated/api/subscriptionActionsResponse';

export const ChangeRequestsPath = () => {
  const { authenticatedUser } = useAuth();
  const { searchResults, total } = useLoaderData() as SubscriptionActionsResponse;

  useTitle([t.H6JV(omaElisaForEmployeeMsg), t.Y29L(orderRequestsMsg)]);

  return (
    <EmployeeOrdersWrapper>
      <EmployeeOrdersBreadcrumb />
      <EmployeeOrdersNavi />
      <Grid>
        <RedeemRequestList
          basePath={paths.EMPLOYEE_CHANGE_REQUEST_ORDER}
          redeemRequests={getFilteredSubscriptionActions(searchResults)}
          totalItems={total}
          authenticatedUser={authenticatedUser}
        />
      </Grid>
    </EmployeeOrdersWrapper>
  );
};
